// extracted by mini-css-extract-plugin
var _1 = "InhabitantTableRow-moduleInhabitantTableRow__YUmcQ TableComponent-modulerow__xPAo4";
export { _1 as "InhabitantTableRow" }
